import React from "react";
import cn from "classnames";

type Props = {
  className?: string;
  withBreakLine?: boolean;
};

export const CountryMetaAllPill: React.FC<Props> = ({
  className,
  withBreakLine,
}) => {
  return (
    <>
      <span
        style={{ fontSize: "10px" }}
        className={cn(
          "px-2 py-1 bg-gray-200 font-bold text-gray-600 text-sm rounded-full",
          className,
        )}
      >
        ALL
      </span>
      {withBreakLine && <br />}
    </>
  );
};
